export const GLOBAL_MEDIA_SCRIPT_MAP = {
  heycar: '245',
  rac: '248',
};
